import ButtonBase from "@mui/material/ButtonBase";
import Divider from "@mui/material/Divider";
import { styled as styling } from "@mui/material/styles";
import Color from "../../../assets/colors";

export const Wrapper = styling("div")({
  margin: "1.875rem 0",

  "@media (max-width: 640px)": {
    margin: "0 0 1.5rem",
  },
});

export const CurrentSearchContainer = styling("div")({
  color: Color.black,
  fontFamily: "Inter",
  fontSize: "1.5rem",
  fontWeight: "600",
  lineHeight: "33.6px",
  whiteSpace: "pre-wrap",
  overflowWrap: "break-word",
});

export const FilterTitleContainer = styling("div")({
  color: Color.black,

  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "0.75rem",

  fontSize: "1.75rem",
  fontWeight: "700",
  lineHeight: "33.6px",

  margin: "1.875rem 0",

  "@media (max-width: 640px)": {
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "0.5rem",

    fontSize: "1.25rem",

    width: "100%",
    margin: "0 0 1.5rem",
  },
});

export const FilterOptionContainer = styling("div")({
  display: "flex",
  alignItems: "center",
  gap: "0.75rem",

  "@media (max-width: 640px)": {
    gap: "0.5rem",
  },
});

export const FilterListContainer = styling("div")({
  display: "flex",
  alignItems: "center",
  gap: "0.875rem",

  height: "52px",
  width: "100%",
  overflowX: "auto",

  "&::-webkit-scrollbar, & *::-webkit-scrollbar": {
    backgroundColor: Color.lightHiredlyPurple,
    borderRadius: 8,
    overflow: "auto",
    height: "4px",
    marginTop: "8px",
  },
  "&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
    backgroundColor: Color.hiredlyPurple,
    borderRadius: 8,
    overflow: "auto",
  },

  padding: "0 0.25rem 1rem 0",

  "@media (max-width: 640px)": {
    gap: "0.5rem",
    padding: "0 0.25rem 0.5rem 0",
  },
});

export const FilterCount = styling("span")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",

  backgroundColor: Color.lightHiredlyPurple,
  borderRadius: "0.25rem",
  border: `0.8px solid ${Color.hiredlyPurple}`,

  fontSize: "0.875rem",
  lineHeight: "1.5rem",

  height: "1.5rem",
  padding: "0 0.5rem",

  margin: "0",

  "@media (max-width: 640px)": {
    fontSize: "0.75rem",
    height: "1.25rem",
    padding: "0 0.4375rem",
  },
});

export const CurrentSearchText = styling("span")({
  color: Color.hiredlyPurple,
});

export const FilterOption = styling(ButtonBase)((props) => ({
  color: Color.black,
  fontFamily: "Inter",
  fontSize: "1.75rem",
  fontWeight: "700",
  lineHeight: "33.6px",

  transition: "all 0.15s ease-in-out",

  ...(props.selected && {
    color: Color.hiredlyPurple,
    textDecoration: "underline",
    textUnderlineOffset: "0.75rem",
    textDecorationThickness: "2px",
  }),

  "&:hover": {
    color: Color.hiredlyPurple,
  },

  "&:disabled": {
    filter: "grayscale(100%)",
    opacity: 0.5,
    cursor: "not-allowed",
    pointerEvents: "none",
  },

  "@media (max-width: 640px)": {
    fontSize: "1.25rem",
    textDecoration: "underline",
    textUnderlineOffset: "0.5rem",
    textDecorationThickness: "2px",
  },
}));

export const FilterChip = styling(ButtonBase)((props) => ({
  backgroundColor: Color.white,
  color: Color.black,
  border: `1px solid ${Color.secondaryGrey}`,
  borderRadius: "6.25rem",

  whiteSpace: "nowrap",

  height: "32px",
  padding: "0 0.75rem",

  transition: "all 0.15s ease-in-out",

  ...(props.selected && {
    backgroundColor: Color.black,
    color: Color.white,
  }),

  "&:hover": {
    border: `1px solid ${Color.hiredlyPurple}`,
    color: Color.hiredlyPurple,
  },

  "&:disabled": {
    opacity: 0.5,
    cursor: "not-allowed",
    pointerEvents: "none",
  },
}));

export const DividerStyled = styling(Divider)({
  backgroundColor: Color.black,

  width: "3px",
  margin: "0px 0.5rem",
});
